<div>
  <app-widget-box description="Easily switch between your accounts.">
    <div class="flex flex-wrap justify-center items-stretch gap-1 mx-auto">
      @for (account of connected_accounts(); track $index) {
      <div class="w-40">
        <app-widget-option value="{{account.address | address}}" [active]="active_account()?.address == account.address"
          (click)="selectAccount(account.address)">
        </app-widget-option>
      </div>
      }
    </div>
    <div>
      <app-widget-button (clicked)="disconnect()" heading="Disconnect Wallet">
      </app-widget-button>
    </div>
  </app-widget-box>
</div>